import React from 'react';
import { useDetectSticky } from '../../hooks/useDetectSticky';
import HBTableColumnHeaders from './HBTableColumnHeaders';
import HBTableFilters from './HBTableFilters';
import styled from 'styled-components';
import { scrollShadow } from '../../styles/mixins';
import { TABLE_Z_INDEX } from './HBTable.styles';
import { HBTableHeaderProps } from './HBTable.types';

function HBTableHeader<T>({ table, tableBodyEl }: HBTableHeaderProps<T>) {
    const { setEl, isStuck } = useDetectSticky<HTMLDivElement>();

    return (
        <Container ref={setEl} $isStuck={isStuck}>
            <HBTableFilters table={table} />
            <HBTableColumnHeaders table={table} tableBodyEl={tableBodyEl} />
        </Container>
    );
}

export default HBTableHeader;

// -------------------------- Styles -------------------------- //

const Container = styled.div<{ $isStuck: boolean }>`
    position: sticky;
    top: 0;
    z-index: ${TABLE_Z_INDEX.TOP};
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    ${({ $isStuck }) =>
        scrollShadow({
            isShadowActive: $isStuck,
            size: 12,
            direction: 'bottom'
        })}
`;
